import { TextArea } from "@blueprintjs/core";
import moment from "moment";
//@ts-ignore
import trLocale from "moment/locale/tr";

import { useEffect, useState } from "react";
import ts from "typescript";
import { PageHider } from "../components/PageHider";
import { WeeklyPage } from "../components/WeeklyPage";
import { WeeklyHeader } from "../components/WeeklyHeader";
import {
  query,
  collection,
  where,
  limit,
  getDocs,
  orderBy,
} from "firebase/firestore";
import { fireStore } from "../../../../firebase";
import { beforePreviousFridayNight } from "../util";
import { useChartDateContext } from "../chart-date-context";
const RESISTANCES = [
  0.24, 0.8, 1.2, 2, 2.4, 3.3, 3.96, 4.5, 5.2, 5.8, 6.2, 6.65, 7, 7.4, 7.8, 8.3,
  9,
];
export const Page2 = ({
  onPageDataUpdated,
  weekData,
  pageIndex,
  subIndex,
  registerPageIndex,
  details,
}: any) => {
  const [comment, setComment] = useState(weekData?.page2?.comment ?? "");
  const [bistData, setBistData] = useState<any>(null);
  const [xu30Data, setXu30Data] = useState<any>(null);
  const [closestResistance, setClosestResistance] = useState<any>(
    weekData?.page2?.resistances ?? [null, null, null, null]
  );
  const [viop30Value, setViop30Value] = useState<any>(
    weekData?.page2?.viop30 ?? ""
  );
  const { chartDate } = useChartDateContext();

  useEffect(() => {
    const previousFriday = beforePreviousFridayNight(chartDate);
    const q = query(
      collection(fireStore, "DS1"),
      where("dateTime", "<=", previousFriday.toDate()),
      orderBy("dateTime", "desc"),
      limit(20)
    );

    getDocs(q).then((querySnapshot: any) => {
      const list: any = [];
      const firstDate = moment();
      querySnapshot.forEach((doc: any) => {
        const date = moment(doc.data().dateTime.toDate());
        if (date.isBefore(firstDate)) {
          const dateIndex = date.days();
          if (
            dateIndex === 5 ||
            (chartDate && moment(chartDate).days() === date.days())
          )
            list.push(doc.data());
        }
      });
      setBistData(list);
    });
  }, [chartDate]);
  useEffect(() => {
    registerPageIndex(pageIndex, subIndex, "Haftalık Değerlendirme");
  }, []);

  useEffect(() => {
    const previousFriday = beforePreviousFridayNight(chartDate);

    const q = query(
      collection(fireStore, "NS_XU030_DAILY"),
      orderBy("dateTime", "desc"),
      where("dateTime", "<=", previousFriday.toDate()),

      limit(20)
    );

    getDocs(q).then((querySnapshot: any) => {
      const list: any = [];
      const firstDate = moment();
      querySnapshot.forEach((doc: any) => {
        const date = moment(doc.data().dateTime.toDate());
        if (date.isBefore(firstDate)) {
          const dateIndex = date.days();

          if (
            dateIndex === 5 ||
            (chartDate && moment(chartDate).days() === date.days())
          ) {
            list.push(doc.data().close);
          }
        }
      });
      setXu30Data(list);
    });
  }, [chartDate]);

  useEffect(() => {
    if (!bistData) return;
    if (closestResistance.filter((item: any) => item !== null).length > 0)
      return;
    const list: any = [];
    RESISTANCES.forEach((item) => {
      list.push({
        diff: Math.abs(bistData?.[0]?.sentiment - item),
        resistance: item,
      });
    });
    list.sort((a: any, b: any) => {
      return a.diff - b.diff;
    });

    setClosestResistance(
      list
        .slice(0, 4)
        .sort((a: any, b: any) => {
          return b.resistance - a.resistance;
        })
        .map((item: any) => item.resistance)
    );
  }, [bistData]);

  return (
    <WeeklyPage pageId={`page-${pageIndex}-${subIndex}`}>
      <WeeklyHeader title="HAFTALIK DEĞERLENDİRME" />
      <div
        style={{
          display: "flex",
          height: "100%",
          gap: "24px",
          padding: "0 10px",
          fontFamily: "Open Sans",
          fontSize: "20px",
        }}
      >
        {/* Sol Kolon - Yorum */}
        <div style={{ width: "50%", display: "flex", flexDirection: "column" }}>
          <div
            style={{
              backgroundColor: "#F7AF3D",
              padding: "5px 10px",
              fontWeight: "600",
              marginBottom: "10px",
              borderRadius: "2px",
            }}
          >
            Haftalık Yorum
          </div>
          <TextArea
            className="no-print"
            style={{
              minHeight: "200px",
              marginBottom: "10px",
              width: "100%",
              fontSize: "20px",
            }}
            placeholder="Haftalık yorum"
            defaultValue={comment}
            onChange={(e) => {
              onPageDataUpdated("page2", "comment", e.target.value);
              setComment(e.target.value);
            }}
          ></TextArea>
          <div
            className="print-only-block"
            style={{
              textAlign: "justify",
              lineHeight: "30px",
              fontSize: "20px",
            }}
          >
            {comment.split("\n").map((item: any, index: number) => (
              <div key={index}>{item}</div>
            ))}
          </div>
        </div>

        {/* Sağ Kolon - Tablolar */}
        <div
          style={{
            width: "50%",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            fontWeight: "600",
          }}
        >
          {/* Sentiment ve Bist 100 Değişimi */}
          <div>
            <div
              style={{
                backgroundColor: "#F7AF3D",
                padding: "5px 10px",
                marginBottom: "10px",
                borderRadius: "2px",
              }}
            >
              Sentiment ve Bist 100 Değişimi
            </div>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "16px",
                borderTop: "1px solid #008099",
                borderBottom: "1px solid #008099",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#008099",
                    color: "white",
                  }}
                >
                  <th
                    style={{
                      padding: "5px",
                      textAlign: "left",
                      border: "1px solid white",
                      borderLeft: "none",
                    }}
                  >
                    Tarih
                  </th>
                  <th
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid white",
                    }}
                  >
                    Sentiment
                  </th>
                  <th
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid white",
                    }}
                  >
                    Günlük Sentiment
                  </th>
                  <th
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid white",
                      borderRight: "none",
                    }}
                  >
                    Bist 100
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  style={{
                    backgroundColor: "white",
                    borderBottom: "1px solid #008099",
                  }}
                >
                  <td
                    style={{
                      padding: "5px",
                      border: "1px solid #008099",
                      borderLeft: "none",
                    }}
                  >
                    {moment(bistData?.[0]?.dateTime.toDate()).format("DD/MM")}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      {Math.abs(
                        bistData?.[0]?.sentiment - bistData?.[1]?.sentiment
                      ) > 0.009 && (
                        <img
                          style={{ position: "absolute", left: "10px" }}
                          height="16"
                          src={
                            bistData?.[0]?.sentiment < bistData?.[1]?.sentiment
                              ? "/images/down_arrow.png"
                              : "/images/up_arrow.png"
                          }
                          alt=""
                        />
                      )}
                      {bistData?.[0]?.sentiment.toFixed(2)}
                    </div>
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      {Math.abs(
                        bistData?.[0]?.sentiment2 - bistData?.[1]?.sentiment2
                      ) > 0.009 && (
                        <img
                          style={{ position: "absolute", left: "10px" }}
                          height="16"
                          src={
                            bistData?.[0]?.sentiment2 <
                            bistData?.[1]?.sentiment2
                              ? "/images/down_arrow.png"
                              : "/images/up_arrow.png"
                          }
                          alt=""
                        />
                      )}
                      {bistData?.[0]?.sentiment2.toFixed(1)}/
                      {bistData?.[0]?.momentum.toFixed(0)}
                    </div>
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                      borderRight: "none",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      {Math.abs(
                        bistData?.[0]?.index_value - bistData?.[1]?.index_value
                      ) > 0.009 && (
                        <img
                          style={{ position: "absolute", left: 0 }}
                          height="16"
                          src={
                            bistData?.[0]?.index_value <
                            bistData?.[1]?.index_value
                              ? "/images/down_arrow.png"
                              : "/images/up_arrow.png"
                          }
                          alt=""
                        />
                      )}
                      {bistData?.[0]?.index_value.toFixed(2)}
                    </div>
                  </td>
                </tr>
                <tr
                  style={{
                    backgroundColor: "rgba(0, 128, 153, 0.2)",
                    borderBottom: "1px solid #008099",
                  }}
                >
                  <td
                    style={{
                      padding: "5px",
                      border: "1px solid #008099",
                      borderLeft: "none",
                    }}
                  >
                    {moment(bistData?.[1]?.dateTime.toDate()).format("DD/MM")}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                    }}
                  >
                    {bistData?.[1]?.sentiment.toFixed(2)}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                    }}
                  >
                    {bistData?.[1]?.sentiment2.toFixed(1)}/
                    {bistData?.[0]?.momentum.toFixed(0)}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                      borderRight: "none",
                    }}
                  >
                    {bistData?.[1]?.index_value.toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Bist 100 ve Bist 30 Değişimleri */}
          <div>
            <div
              style={{
                backgroundColor: "#F7AF3D",
                padding: "5px 10px",
                marginBottom: "10px",
                borderRadius: "2px",
              }}
            >
              Bist 100 ve Bist 30 Değişimleri
            </div>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "16px",
                borderTop: "1px solid #008099",
                borderBottom: "1px solid #008099",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#008099",
                    color: "white",
                  }}
                >
                  <th
                    style={{
                      padding: "5px",
                      textAlign: "left",
                      border: "1px solid #008099",
                      borderLeft: "none",
                    }}
                  >
                    Endeks
                  </th>
                  <th
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                    }}
                  >
                    Bu Hafta (
                    {moment(bistData?.[0]?.dateTime.toDate()).format("DD/MM")})
                  </th>
                  <th
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                    }}
                  >
                    Önceki Hafta (
                    {moment(bistData?.[1]?.dateTime.toDate()).format("DD/MM")})
                  </th>
                  <th
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                      borderRight: "none",
                    }}
                  >
                    Haftalık Değişim %
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  style={{
                    backgroundColor: "white",
                    borderBottom: "1px solid #008099",
                  }}
                >
                  <td
                    style={{
                      padding: "5px",
                      border: "1px solid #008099",
                      borderLeft: "none",
                    }}
                  >
                    BİST 100
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                    }}
                  >
                    {bistData?.[0]?.index_value.toFixed(2)}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                    }}
                  >
                    {bistData?.[1]?.index_value.toFixed(2)}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                      borderRight: "none",
                    }}
                  >
                    %
                    {(
                      ((bistData?.[0]?.index_value -
                        bistData?.[1]?.index_value) *
                        100) /
                      bistData?.[1]?.index_value
                    ).toFixed(2)}
                  </td>
                </tr>
                <tr
                  style={{
                    backgroundColor: "rgba(0, 128, 153, 0.2)",
                    borderBottom: "1px solid #008099",
                  }}
                >
                  <td
                    style={{
                      padding: "5px",
                      border: "1px solid #008099",
                      borderLeft: "none",
                    }}
                  >
                    BİST 30
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                    }}
                  >
                    {xu30Data?.[0]?.toFixed(2)}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                    }}
                  >
                    {xu30Data?.[1]?.toFixed(2)}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                      borderRight: "none",
                    }}
                  >
                    %
                    {(
                      ((xu30Data?.[0] - xu30Data?.[1]) * 100) /
                      xu30Data?.[1]
                    ).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Viop */}
          <div>
            <div
              style={{
                backgroundColor: "#F7AF3D",
                padding: "5px 10px",
                marginBottom: "10px",
                borderRadius: "2px",
              }}
            >
              Viop
            </div>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "16px",
                borderTop: "1px solid #008099",
                borderBottom: "1px solid #008099",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#008099",
                    color: "white",
                  }}
                >
                  <th
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                      borderLeft: "none",
                    }}
                  >
                    Endeks
                  </th>
                  <th
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                      borderRight: "none",
                    }}
                  >
                    Değer
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  style={{
                    backgroundColor: "white",
                    borderBottom: "1px solid #008099",
                  }}
                >
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                      borderLeft: "none",
                    }}
                  >
                    XU030 Viop
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      border: "1px solid #008099",
                      borderRight: "none",
                    }}
                  >
                    <input
                      className="no-print"
                      defaultValue={viop30Value}
                      style={{ width: "80px", textAlign: "center" }}
                      onChange={(e) => {
                        onPageDataUpdated("page2", "viop30", e.target.value);
                        setViop30Value(e.target.value);
                      }}
                    ></input>
                    <span className="print-only-inline-block">
                      {viop30Value}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Sentiment Önemli Destek ve Dirençler */}
          <div>
            <div
              style={{
                backgroundColor: "#F7AF3D",
                padding: "5px 10px",
                marginBottom: "10px",
                borderRadius: "2px",
              }}
            >
              Sentiment Önemli Destek ve Dirençler
            </div>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "16px",
                borderTop: "1px solid #008099",
                borderBottom: "1px solid #008099",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#008099",
                    color: "white",
                  }}
                >
                  {closestResistance?.map((_: any, index: number) => (
                    <th
                      key={index}
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                        borderLeft: index === 0 ? "none" : "1px solid #008099",
                        borderRight:
                          index === closestResistance.length - 1
                            ? "none"
                            : "1px solid #008099",
                      }}
                    >
                      {index + 1}. Seviye
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr
                  style={{
                    backgroundColor: "white",
                    borderBottom: "1px solid #008099",
                  }}
                >
                  {closestResistance?.map((res: number, index: number) => (
                    <td
                      key={index}
                      style={{
                        padding: "5px",
                        textAlign: "center",
                        border: "1px solid #008099",
                        borderLeft: index === 0 ? "none" : "1px solid #008099",
                        borderRight:
                          index === closestResistance.length - 1
                            ? "none"
                            : "1px solid #008099",
                      }}
                    >
                      <input
                        style={{ width: "50px", textAlign: "center" }}
                        className="no-print"
                        value={res || ""}
                        onChange={(e) => {
                          const newVal = [...closestResistance];
                          newVal[index] = e.target.value;
                          setClosestResistance(newVal);
                          onPageDataUpdated("page2", "resistances", newVal);
                        }}
                      ></input>
                      <span className="print-only-inline-block">{res}</span>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </WeeklyPage>
  );
};
